<div class="modal active">
  <div class="modal__container">
    <div class="fields">
      <h2>Coordinates</h2>
      <div class="close" (click)="cancelCoordinates()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngCoordinates" #ngForm="ngForm" id="coordinatesForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">

              <div class="input-fields">
                <div>
                  <label for="">Latitude</label>
                  <div class="coordenates">
                    <div>
                      <select
                      name="latCardinal"
                      [(ngModel)]="coordinatesModel.latLonDms.latitude.cardinal"
                      (ngModelChange)="coordinatesModel.latitude = coordinatesModel.latLonDms.toLat()"
                      style="width: auto">
                      <option value="N">N</option>
                      <option value="S">S</option>
                    </select>
                    <input
                      type="number"
                      id="latDegrees"
                      name="latDegrees"
                      [(ngModel)]="
                      coordinatesModel.latLonDms.latitude.degrees
                      "
                      (ngModelChange)="
                      coordinatesModel.latitude = coordinatesModel.latLonDms.toLat()
                      "
                      style="width: 16%"
                    /><span>º</span
                    ><input
                      type="number"
                      id="latMinutes"
                      name="latMinutes"
                      [(ngModel)]="
                      coordinatesModel.latLonDms.latitude.minutes
                      "
                      (ngModelChange)="
                      coordinatesModel.latitude = coordinatesModel.latLonDms.toLat()
                      "
                      style="width: 16%"
                    /><span>´</span
                    ><input
                      type="number"
                      id="latSeconds"
                      name="latSeconds"
                      [(ngModel)]="
                      coordinatesModel.latLonDms.latitude.seconds
                      "
                      (ngModelChange)="
                      coordinatesModel.latitude = coordinatesModel.latLonDms.toLat()
                      "
                      style="width: 16%"
                    /><span>´´</span>
                    </div>
                    <br /><input
                      [(ngModel)]="coordinatesModel.latitude"
                      (ngModelChange)="
                        coordinatesModel.latLonDms.fromLat(
                          coordinatesModel.latitude
                        )
                      "
                      type="number"
                      style="width: 75%; margin-top: 5px"
                      id="latitude"
                      name="latitude"
                      required
                      #latitude="ngModel"
                    /><span></span>
                  </div>
                </div>
                <div>
                  <label for="">Longitude</label>
                  <div class="coordenates">
                    <div>
                      <select
                      name="lonCardinal"
                      [(ngModel)]="coordinatesModel.latLonDms.longitude.cardinal"
                      (ngModelChange)="coordinatesModel.longitude = coordinatesModel.latLonDms.toLon()"
                      style="width: auto">
                      <option value="E">E</option>
                      <option value="W">W</option></select
                    ><input
                      type="number"
                      id="lonDegrees"
                      name="lonDegrees"
                      [(ngModel)]="coordinatesModel.latLonDms.longitude.degrees"
                      (ngModelChange)="coordinatesModel.longitude = coordinatesModel.latLonDms.toLon()"
                      style="width: 16%"
                    /><span>º</span
                    ><input
                      type="number"
                      id="lonMinutes"
                      name="lonMinutes"
                      [(ngModel)]="
                        coordinatesModel.latLonDms.longitude
                          .minutes
                      "
                      (ngModelChange)="
                        coordinatesModel.longitude = coordinatesModel.latLonDms.toLon()
                      "
                      style="width: 16%"
                    /><span>´</span
                    ><input
                      type="number"
                      id="lonSeconds"
                      name="lonSeconds"
                      [(ngModel)]="
                        coordinatesModel.latLonDms.longitude
                          .seconds
                      "
                      (ngModelChange)="
                        coordinatesModel.longitude = coordinatesModel.latLonDms.toLon()
                      "
                      style="width: 16%"
                    /><span></span>
                    </div>
                    <br /><input
                      [(ngModel)]="coordinatesModel.longitude"
                      (ngModelChange)="
                        coordinatesModel.latLonDms.fromLon(
                          coordinatesModel.longitude
                        )
                      "
                      type="number"
                      style="width: 75%; margin-top: 5px"
                      id="longitude"
                      name="longitude"
                      required
                      #longitude="ngModel"
                    /><span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="saveCoordinates();" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancelCoordinates()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
